module.exports = __webpack_public_path__ + "img/ic-check.2dd6e1b2.svg";